import React from 'react';

import { ListingCard } from '../../components';

import css from './ProfilePage.module.css';

/**
 * SSR-safe fallback for the similar sellers section.
 *
 * @param {Object} props
 * @param {Array<Object>} props.sellers seller entries
 * @param {Object} props.intl react-intl
 * @returns {JSX.Element}
 */
const SimilarSellersFallback = props => {
  const { sellers, intl } = props;
  const ctaText = intl.formatMessage({ id: 'ProfilePage.similarSellersViewCollection' });

  return (
    <div className={css.similarSellersGrid} role="list">
      {sellers.map(seller => (
        <div key={seller.id} className={css.similarSellersItem} role="listitem">
          <ListingCard
            className={css.similarSellersCard}
            variant="verifiedCreatorCollection"
            thumbnailImage={seller.profileImage}
            thumbnailAlt={seller.name}
            itemsCountText={seller.itemsCountText}
            categoryLabel={seller.category}
            creatorName={seller.name}
            creatorSubtitle={seller.subtitle}
            ctaText={ctaText}
            ctaHref={seller.profileHref}
            intl={intl}
          />
        </div>
      ))}
    </div>
  );
};

export default SimilarSellersFallback;
